// ==================
// New flow constants
// ==================

// Used in redux UI fetch state
export const FETCH_STATUSES = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
}

export const FULL_PAGE_LAYOUT_PATHS = ['/summary', '/rewards']

/**
 * Flow modal request paths to identify the new flow modal
 */
export const NEW_FLOW_MODAL_PATHS = [
  '/address/',
  '/replace',
  // BDMC standalone cancel only — PPDC uses /manage/:cardId/cancel (v1 ModalNav layout).
  '/cancel-card',
  '/activate',
  '/create-pin',
  '/page',
  '/enroll',
  '/show-card',
  '/lost-card-post-stepup',
  '/lowbalance',
  '/request-physical-card',
  '/setup-fi',
  '/recurring-payments-dashboard',
  '/faq',
  '/optout',
]

export const ERROR_PAGE_TYPES = {
  UNEXPECTED_CLIENT_ERROR: 'UNEXPECTED_CLIENT_ERROR',
  REQUEST_BLOCKED: 'REQUEST_BLOCKED',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  UNEXPECTED_SERVER_ERROR: 'UNEXPECTED_SERVER_ERROR',
  SERVER_RETRY_ERROR: 'SERVER_RETRY_ERROR',
  NO_INTERNET_ERROR: 'NO_INTERNET_ERROR',
  RISK_DENIED_ERROR: 'RISK_DENIED_ERROR',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  NEED_MORE_DATA: 'NEED_MORE_DATA',
  RISK_STEPUP_SERVICE_FAILURE: 'RISK_STEPUP_SERVICE_FAILURE',
  PAYROLL_PROVIDER_GENERIC_ERROR: 'PAYROLL_PROVIDER_GENERIC_ERROR',
}

export const FLOW_PATHS = {
  REQUEST_PHYSICAL_CARD: '/request-physical-card',
}
